import React, { useRef } from 'react'
import { useLocation, useNavigate } from 'react-router'
import { Modal } from 'components/Utility/Modal/Modal'

/** Lets a step inside the modal take over the modal's back button */
export const BackContext = React.createContext<React.MutableRefObject<(() => void) | null>>({ current: null })

type HashRouteModalProps = {
  hash: string,
  /** A path to go back to, or a handler */
  back?: string | (() => void),
  /** Close with history back instead of clearing the hash */
  backOnClose?: boolean,
  children: React.ReactNode,
  [modalProp: string]: unknown,
}

/** A modal that is open while the URL hash matches, e.g. '#profile' */
export const HashRouteModal: React.FC<HashRouteModalProps> = (props) => {
  const { hash, back, backOnClose = false, children, ...modalProps } = props
  const location = useLocation()
  const navigate = useNavigate()
  const innerBackHandler = useRef<(() => void) | null>(null)

  const onClose = () => {
    if (backOnClose) {
      navigate(-1)
    } else {
      navigate('#')
    }
  }

  const onBack = () => {
    if (innerBackHandler.current) {
      innerBackHandler.current()
      return
    }
    if (typeof back === 'function') {
      back()
    } else if (back !== undefined) {
      navigate(back, { replace: true })
    }
  }

  return (
    <Modal
      back={back ? onBack : undefined}
      onClose={onClose}
      {...modalProps}
      isOpen={location.hash === hash}
    >
      <BackContext.Provider value={innerBackHandler}>
        {children}
      </BackContext.Provider>
    </Modal>
  )
}
